<script>
import utils from '@/utils/common';
import TaskViewDatePopup from './TaskViewDatePopup.vue';

export default {
  name: 'TaskViewDateDispatcher',
  components: { TaskViewDatePopup },
  props: {
    action: String,
    tasks: Array,
    isOpened: Boolean,
  },
  computed: {
    changedTasksWord() {
      return utils.pluralWord(this.tasks.length, 'задаче', 'задачах', 'задачах');
    },

    subTitle() {
      return {
        dateStart: 'начало',
        dateFinish: 'завершение',
      };
    },

    dateName() {
      return this.action === 'dateStart' ? 'Дата начала' : 'Дата завершения';
    },

    question() {
      return {
        dateStart: `Вы действительно хотите установить новую дату начала в ${this.changedTasksWord}?`,
        dateFinish: `Вы действительно хотите установить новую дату завершения в ${this.changedTasksWord}?`,
      };
    },

    questionToDefault() {
      return {
        dateStart: `Вы действительно хотите сбросить дату начала в ${this.changedTasksWord}?`,
        dateFinish: `Вы действительно хотите сбросить дату завершения в ${this.changedTasksWord}?`,
      };
    },
  },
  methods: {
    async submit(value) {
      const question = value ? this.question[this.action] : this.questionToDefault[this.action];
      const text = value ? `${this.dateName} установлена` : `${this.dateName} удалена`;

      if (await this.$confirm(question)) {
        this.$emit('submit', { result: { [this.action]: value }, onSuccess: () => { this.$push({ text }); } });
      }
    },
  },
};
</script>

<template lang="pug">
TaskViewDatePopup(v-if="isOpened" :subTitle="subTitle[this.action]" @submit="submit" @close="$emit('close')")
</template>

<style scoped lang="scss">

</style>
